<template>
  <div class="progressbar" :style="{ width }"></div>
</template>

<script>
export default {
    name: 'ProgressBar',
    data: () => ({
      width: '0%',
    }),
    props: {
        progress: Number,
        totalSteps: Number,
    },
    methods: {
        /**
         * Returns a percentage (integer) between the 2 input values.
         *
         * @param partialValue (mandatory) the partial value (number)
         * @param totalValue (mandatory) the total value (number)
         */
        getPercentage: function(partialValue, totalValue){
            return Math.trunc((100 * partialValue) / totalValue);
        },
    },
    watch: {
        progress: function (newVal){
          this.width = this.totalSteps > 0 ? `${this.getPercentage(newVal, this.totalSteps)}%` : '0%'
        }
    },
}
</script>

<style lang="scss">
  .progressbar{
    background-color: $orange--neutral-2;
    height: 5px;
    transition: width 1.3s ease;
  }

  @media (min-width: $desktop-screen) {
    .progressbar{ transition-duration: 1s;}
  }
</style>